import Ink from "@frog/source/utility/integration/Ink.js"
import * as Ribbit from "@frog/source/utility/Ribbit.js"
import Stage from "@frog/source/models/Stage.js"
import Step from "@frog/source/models/Step.js"

const VALUE_BETWEEN_PARENTHESES = /\(([^)]+)\)/

export default function InkDialogue(knotname, stage) {
    const scriptLines = Ink.loadDialogue(knotname, stage)
    if(scriptLines.length == 0) return []

    const cueboxes = []
    let runningBoxRegister = {
        "lines": [],
        "tags": [],
    }
    for(const scriptLine of scriptLines) {
        const cues = scriptLine.words.split(":")
        if(cues[0].toUpperCase() === cues[0]) {
            cueboxes.push(runningBoxRegister)
            runningBoxRegister = {
                "lines": [],
                "tags": [],
            }
        }
        runningBoxRegister.lines.push(scriptLine.words)
        scriptLine.tags.forEach((flag) => runningBoxRegister.tags.push(flag))
    }
    console.log(cueboxes)

    const steps = cueboxes.map((box) => {
        return Ribbit.convertBoxToSteps({
            "cuebox": box,
            "stage": stage
        })
    }).concat(Step.instantiate({
        "name": "SavestateCapture",
        "alphastage": stage,
        "savestateSlug": knotname,
        "data": {
            "knotname": knotname
        }
    }))

    return steps
}
